import React from 'react';
import { MessageCircle, Send, BookOpen } from 'lucide-react';

const Footer = () => {
  const footerLinks = {
    product: [
      { name: 'Features', href: '#features' },
      { name: 'NFT Marketplace', href: '#nfts' },
      { name: 'Tokenomics', href: '#tokenomics' },
      { name: 'Roadmap', href: '#roadmap' }
    ],
    resources: [
      { name: 'Documentation', href: '#' },
      { name: 'Whitepaper', href: '#' },
      { name: 'Blog', href: '#' },
      { name: 'Support', href: '#' }
    ],
    community: [
      { name: 'Discord', href: '#' },
      { name: 'Twitter', href: '#' },
      { name: 'Telegram', href: '#' },
      { name: 'Medium', href: '#' }
    ]
  };

  return (
    <footer className="bg-[#121212] border-t border-[rgba(255,255,255,0.25)] py-16">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center mb-6">
              <img 
                src="/logo.png" 
                alt="PIOFarming Game Logo" 
                className="h-20 w-auto object-contain"
              />
            </div>
            <p className="text-[16px] font-normal leading-[1.4] text-[rgba(255,255,255,0.85)] mb-6 max-w-sm">
              The first blockchain farming game on Pio network. Farm, earn, and truly own your digital assets.
            </p>
            <div className="flex items-center gap-4">
              <a
                href="#"
                className="w-10 h-10 bg-[rgba(255,255,255,0.1)] hover:bg-[#00FFD1] flex items-center justify-center transition-all duration-300 group"
              >
                <svg className="w-5 h-5 text-white group-hover:text-black" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[rgba(255,255,255,0.1)] hover:bg-[#00FFD1] flex items-center justify-center transition-all duration-300 group"
              >
                <MessageCircle className="w-5 h-5 text-white group-hover:text-black" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[rgba(255,255,255,0.1)] hover:bg-[#00FFD1] flex items-center justify-center transition-all duration-300 group"
              >
                <Send className="w-5 h-5 text-white group-hover:text-black" />
              </a>
              <a
                href="#"
                className="w-10 h-10 bg-[rgba(255,255,255,0.1)] hover:bg-[#00FFD1] flex items-center justify-center transition-all duration-300 group"
              >
                <BookOpen className="w-5 h-5 text-white group-hover:text-black" />
              </a>
            </div>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-[18px] font-semibold text-white mb-4">Product</h3>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[16px] text-[#4D4D4D] hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h3 className="text-[18px] font-semibold text-white mb-4">Resources</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[16px] text-[#4D4D4D] hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Community Links */}
          <div>
            <h3 className="text-[18px] font-semibold text-white mb-4">Community</h3>
            <ul className="space-y-3">
              {footerLinks.community.map((link) => (
                <li key={link.name}>
                  <a
                    href={link.href}
                    className="text-[16px] text-[#4D4D4D] hover:text-white transition-colors duration-300"
                  >
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-[rgba(255,255,255,0.25)] flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[16px] text-[#4D4D4D]">
            © 2026 PIOFarming Game. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-[16px] text-[#4D4D4D] hover:text-white transition-colors duration-300">
              Privacy Policy
            </a>
            <a href="#" className="text-[16px] text-[#4D4D4D] hover:text-white transition-colors duration-300">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
